export default __webpack_public_path__ + "static/media/post_step3.7f5d1a7c.png";